import { useEffect, useState } from 'react';
import PostingsApi from '../../../../../../API/shipment/postings-api';
import minus from '../../../../../../assets/media/icons/minus.svg';
import plus from '../../../../../../assets/media/icons/plus.svg';
import { Row } from '../../../../../../components/Basic/Blocks';
import { Button } from '../../../../../../components/Basic/Buttons';
import { Icon } from '../../../../../../components/Basic/Elements';
import { Input } from '../../../../../../components/Basic/Inputs';
import { TYPE_BUTTONS } from '../../../../../../constans';

const Stepper = ({ item = {}, skladName, order = {}, save = () => { }, ...props }) => {
  const [value, setValue] = useState(0);

  const [showReasonDebit, setShowReasonDebit] = useState(false);

  const onChange = async (value, reason = '') => {
    await PostingsApi.addOverage({
      data: {
        postingNumber: order.posting_number,
        productId: item._id,
        overageQuantity: parseInt(value),
      }
    })
      .then((r) => {
        save(r);
        setValue(0);
      })
      .catch();
  };

  const clickAdd = async () => {
    if (value > 0) {
      onChange(value);
    }
  };

  const clickDebit = async () => {
    if (value > 0) {
      onChange(0 - value); // передаем отрицательное число
    }
    //setShowReasonDebit(false);
  };
  useEffect(() => {
    console.log(item.diff.value != 0, item);
    setValue(Math.max((item.diff.value = 0 ? item.diff.value - item.diff.overage_quantity : item.common_quantity), 0));
  }, []);

  const reserved = 0; //item.sklad_data?.[skladName]?.shipment_reserved + item.sklad_data?.[skladName]?.hand_reserved;

  return (
    <Row>
      <Button
        type={TYPE_BUTTONS.WHITE}
        style={{ width: '27px', height: '27px', padding: 0, marginRight: '10px' }}
        disabled={item.diff.overage_quantity < value || !item.diff.overage_quantity}
        onClick={() => clickDebit()}
      >
        <Icon src={minus} width="16px" />
      </Button>
      <Input value={value} onChange={(v) => setValue(v)} style={{ width: '25px' }} center />
      <Button
        type={TYPE_BUTTONS.WHITE}
        style={{ width: '27px', height: '27px', padding: 0, marginLeft: '10px' }}
        onClick={clickAdd}
      >
        <Icon src={plus} width="15px" />
      </Button>
      {showReasonDebit && (
        <ReasonStockDebit clickOk={(reason) => clickDebit(reason)} close={() => setShowReasonDebit(false)} />
      )}
    </Row>
  );
};

export default Stepper;
